package info.rezident.app.data

import kotlinx.serialization.Serializable
import kotlin.js.Date

@Serializable
enum class HomePageVariant(val titleText: String, val subtitleText: String) {
    A("Descoperă-ți\nspecialitatea la ", "Află totul despre specialitățile care ți se potrivesc"),
    B("Descoperă-ți\nspecialitatea la ", "Află care specialități ți se potrivesc mai mult"),
    C("Descoperă\nspecialitățile la ", "Află totul despre specialitățile care ți se potrivesc"),
    D("Descoperă\nspecialitățile la ", "Află care specialități ți se potrivesc mai mult"),
    E("Află în 2 minute\nspecialitatea la ", "Descoperă totul despre specialitățile care ți se potrivesc"),
    F("Află în 2 minute\nspecialitatea la ", "Descoperă care specialități ți se potrivesc mai mult"),
    G("Află în câteva minute\nspecialitatea la ", "Descoperă totul despre specialitățile care ți se potrivesc"),
    H("Află în câteva minute\nspecialitatea la ", "Descoperă care specialități ți se potrivesc mai mult");

    companion object {
        const val KEY = "home_variant"
    }
}

@Serializable
enum class CTAVariant(val buttonText: String) {
    A("Descoperă acum"),
    B("Începe acum"),
    C("Începe explorarea"),
    D("Obține informații");

    companion object {
        const val KEY = "cta_variant"
    }
}

@Serializable
enum class MembershipType {
    FREE, PAY_PER_USE, SUBSCRIPTION_MONTHLY, SUBSCRIPTION_YEARLY
}

@Serializable
enum class PriceVariant(
    val subscriptionMonthlyFullPrice: Double,
    val subscriptionMonthlySalePrice: Double,
    val subscriptionMonthlyDiscount: Int,
    val subscriptionYearlyFullPrice: Double,
    val subscriptionYearlySalePrice: Double,
    val subscriptionYearlyDiscount: Int,
    val payPerUsePrice: Double
) {
    A(
        subscriptionMonthlyFullPrice = 34.49,
        subscriptionMonthlySalePrice = 29.99,
        subscriptionMonthlyDiscount = 15,
        subscriptionYearlyFullPrice = 413.9,
        subscriptionYearlySalePrice = 129.99,
        subscriptionYearlyDiscount = 68,
        payPerUsePrice = 19.99
    ),
    B(
        subscriptionMonthlyFullPrice = 45.99,
        subscriptionMonthlySalePrice = 39.99,
        subscriptionMonthlyDiscount = 15,
        subscriptionYearlyFullPrice = 551.9,
        subscriptionYearlySalePrice = 149.99,
        subscriptionYearlyDiscount = 68,
        payPerUsePrice = 24.99
    ),
    C(
        subscriptionMonthlyFullPrice = 57.49,
        subscriptionMonthlySalePrice = 49.99,
        subscriptionMonthlyDiscount = 15,
        subscriptionYearlyFullPrice = 689.9,
        subscriptionYearlySalePrice = 199.99,
        subscriptionYearlyDiscount = 71,
        payPerUsePrice = 34.99
    ),
    D(
        subscriptionMonthlyFullPrice = 24.99,
        subscriptionMonthlySalePrice = 14.99,
        subscriptionMonthlyDiscount = 50,
        subscriptionYearlyFullPrice = 329.99,
        subscriptionYearlySalePrice = 99.99,
        subscriptionYearlyDiscount = 70,
        payPerUsePrice = 14.99
    );

    companion object {
        const val KEY = "pricing_variant"
        val default = C
    }
}

@Serializable
data class ContactMessage(
    val name: String,
    val email: String,
    val phoneNumber: String? = null,
    val message: String,
    val dateCreated: String = Date().toISOString()
)